import { ApiRes } from "@/api/api-res";
import { UserSummaryItem } from "@/models/user-summary/UserSummaryItem";

export class EventSummary extends UserSummaryItem {
  public static build(json: ApiRes.UserSummaryEvent): EventSummary {
    return new EventSummary(json.event_name, json.count, json.rate);
  }
}
